"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStoresApi = void 0;
var _react = require("@reduxjs/toolkit/query/react");
var _objects = require("../utilities/objects");
const createStoresApi = _ref => {
  let {
    baseUrl,
    slice,
    tokenName
  } = _ref;
  return (0, _react.createApi)({
    reducerPath: 'storesApi',
    baseQuery: (0, _react.fetchBaseQuery)({
      baseUrl: `${baseUrl}/pos/`,
      credentials: 'include',
      prepareHeaders: (headers, _ref2) => {
        var _getState$slice;
        let {
          getState
        } = _ref2;
        const token = (_getState$slice = getState()[slice]) === null || _getState$slice === void 0 ? void 0 : _getState$slice[tokenName];
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      }
    }),
    endpoints: builder => ({
      createStore: builder.mutation({
        query: _ref3 => {
          let {
            body
          } = _ref3;
          return {
            body,
            method: 'POST',
            url: 'stores'
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      deleteStore: builder.query({
        query: _ref4 => {
          let {
            storeId
          } = _ref4;
          return {
            method: 'DELETE',
            url: `stores/${storeId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getStore: builder.query({
        query: _ref5 => {
          let {
            storeId
          } = _ref5;
          return {
            method: 'GET',
            url: `stores/${storeId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getStores: builder.query({
        query: _ref6 => {
          let {
            params
          } = _ref6;
          return {
            method: 'GET',
            url: 'stores',
            params
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      updateStore: builder.mutation({
        query: _ref7 => {
          let {
            body,
            storeId
          } = _ref7;
          return {
            body,
            method: 'PATCH',
            url: `stores/${storeId}`
          };
        }
      }),
      syncCBR: builder.mutation({
        query: body => ({
          body,
          method: 'POST',
          url: 'cbr'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      syncClutch: builder.mutation({
        query: body => ({
          body,
          method: 'POST',
          url: 'clutch'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      syncTeamwork: builder.mutation({
        query: body => ({
          body,
          method: 'POST',
          url: 'teamwork'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      })
    })
  });
};
exports.createStoresApi = createStoresApi;